import { forwardRef, useState } from 'react';

import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';

import useBreakpoints from '#client/hooks/useBreakpoints';

import OfferCard from './OfferCard';
import OfferCardSkeleton from './OfferCardSkeleton';

import useBankingCardOffers from '../hooks/useBankingCardOffers';

export const Offers = forwardRef((props, ref) => {
  const {
    sizes: { isMobile }
  } = useBreakpoints();
  const { loading: isLoadingBankingCards, bankingCards } = useBankingCardOffers();

  const [openCardIndex, setOpenCardIndex] = useState(null);

  const handleToggle = (index) => {
    setOpenCardIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const renderBankingCards = () => {
    if (isLoadingBankingCards) {
      return <OfferCardSkeleton />;
    }

    if (bankingCards.length === 0) {
      return <Text>No business banking solutions available</Text>;
    }

    return bankingCards.map((card, index) => (
      <OfferCard
        isOpen={openCardIndex === index}
        key={card.id}
        onToggle={() => handleToggle(index)}
        {...card}
      />
    ));
  };

  return (
    <Stack
      spacing={4}
      {...props}
      ref={ref}
    >
      <Text
        color="primary"
        size="xl"
        weight="medium"
      >
        Business Banking Solutions
      </Text>
      <Stack
        direction={isMobile ? 'column' : 'row'}
        flexWrap={isMobile ? 'nowrap' : 'wrap'}
        spacing={isMobile ? 2 : 1}
      >
        {renderBankingCards()}
      </Stack>
    </Stack>
  );
});
